import React, { useState, useReducer, useRef, useEffect } from "react";

import classes from './Verification.module.css';
import classes2 from "./Login.module.css";

import FormButton from "../../Button/FormButton/FormButton";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import { VerifyHandler } from "../../../../store/auth-actions";
import Input1 from "../../Inputs/Input1";
import { Link } from "react-router-dom";
import { resendOTP } from "../../../../Api Methods/Api";
import VerifyCode from "./VerifyCode";
import { serviceActions } from "../../../../store/service-Slice";
import mixpanel from "mixpanel-browser";
import { reactToString } from "rsuite/esm/internals/utils";

const extraLinks = [
    {
        LinkTextBold: "Activite Account",
    },
    {
        LinkTextBold: "User Legacy Portal",
    },
]


const verifyCodeReducer = (state, action) => {
    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: true };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: true };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: state.value.includes('@') };
    }
    //otherwise 
    return { value: '', isValid: false };
};


const FormCard = (props) => {
    const [formIsValid, setFormIsValid] = useState(false);

    const [verifyCodeState, setVerifyCodeState] = useState({
        value: "",
        isValid: true
    });

    const verifyCodeInputRef = useRef()

    const { isValid: verifyCodeIsValid } = verifyCodeState;

    useEffect(() => {
        const identifier = setTimeout(() => {
            // console.log('Checking form validity!');
            setFormIsValid(verifyCodeIsValid)
        }, 500);

        return () => {
            // console.log('CLEANUP');
            clearTimeout(identifier);
        };
    }, [verifyCodeIsValid]);



    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const loginData = location.state;

    // If no login data (user navigated directly to /Verify), redirect to login
    useEffect(() => {
        if (!loginData) {
            navigate("/", { replace: true });
        }
    }, [loginData, navigate]);

    const email = loginData?.email;

    useEffect(() => {
        if (email) {
            dispatch(serviceActions.setUserEmail(email));
        }
    }, [email, dispatch]);

    const submitHandler = (event) => {
        event.preventDefault();

        if (formIsValid) {


            const verifyCode = verifyCodeState.value;

            const { token, client, refreshToken, groups, getAllDevices } = loginData;
            dispatch(VerifyHandler(email, verifyCode, { token, client, refreshToken, groups, getAllDevices })).then((response) => {
                if (response && response.data && response.data.success) {
                    navigate('/Dashboard')
                    //successful login
                    mixpanel.identify(email)
                    mixpanel.people.set({
                        $email: email
                    })

                    mixpanel.track(
                        "Successful login",{
                            user: email
                        }
                    )

                    //store user data here instead?

                } else {
                    if (!response.data.success){
                        mixpanel.track(
                            "Failed login, incorrect 2FA code entered",{
                                user: email
                            }
                        )
                    }
                }
            })


            // onClearHandler();

            return;
        } else if (!verifyCodeIsValid) {
            verifyCodeInputRef.current.focus();
        }
    };

    return (
        <div className={`${classes.card} ${props.className}`}>
            <h2 className={classes2.Title}>{"Verification"}</h2>
            <p className={classes2.subInfo}>{props.subInfo || "We've sent you a code via app notification & email"}</p>

            <form onSubmit={submitHandler} className={classes2["container"]} >
                <ul className={classes2["inputs-list"]}>
                <VerifyCode
                    onComplete={(code) => {
                        setVerifyCodeState({ value: code, isValid: true });
                    }}
                />

                </ul>
                <FormButton style={{ marginTop: "20px" }} value={"Verify"} type="submit" />
            </form>

            <div>
                <ul className={classes["extraLinks-list"]}>
                    {(props.extraLinks || extraLinks).map((extraLink, index) => (
                        <li className={classes.listItem} key={index}>
                            <h4 className={classes.extraLink}>{extraLink.LinkText || ""}</h4> <h4 onClick={() => resendOTP(email)} className={classes.link}>{extraLink.LinkTextBold}</h4>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default FormCard;